import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import AdvancedSearchHelper from '../../AdvancedSearchHelper';
import { limitSelectOptions, casefoldersSelectOptions, querySelectOptions, regionSelectOptions } from '../../formData';
import FieldSet from '../../../Modules/FieldSet';
import {
  SearchPDFsField,
  CasesField,
  RegionField,
  QueryField,
  CaseTitlesField,
  PartyNameField,
  DatePickerField,
  InputField,
} from '../../fields';

import '../../AdvancedSearch.less';

export const CasesForm = ({ filter, onSubmit, onReset }) => (
  <Form
    onSubmit={onSubmit}
    initialValues={filter}
    render={({ handleSubmit, form }) => (
      <form onSubmit={handleSubmit} className="advanced-search-form">
        <InputField placeholder="Enter case title, party name or case number" />
        <AdvancedSearchHelper />
        <div className="advanced-search-filters">
          <FieldSet title="Advanced Filters">
            <div className="form-item form-item-row">
              <div className="col-2">
                <SearchPDFsField limitSelectOptions={limitSelectOptions} disabled />
              </div>
              <div className="col-2">
                <CasesField casefoldersSelectOptions={casefoldersSelectOptions} />
              </div>
            </div>
          </FieldSet>
          <FieldSet title="Case Information">
            <div className="form-item form-item-row">
              <div className="col-2">
                <RegionField regionSelectOptions={regionSelectOptions} />
              </div>
              <div className="col-2">
                <QueryField querySelectOptions={querySelectOptions} disabled />
              </div>
            </div>
            <div className="form-item form-item-row">
              <div className="col-2">
                <CaseTitlesField limitSelectOptions={limitSelectOptions} />
              </div>
              <div className="col-2">
                <PartyNameField limitSelectOptions={limitSelectOptions} />
              </div>
            </div>
          </FieldSet>
          <FieldSet title="Date Filters">
            <div className="form-item">
              <label>Cases filed</label>
              <div className="form-item-row">
                <DatePickerField fieldName="date_filed_from" placeholderText="From" />
                <DatePickerField fieldName="date_filed_to" placeholderText="Through" />
              </div>
            </div>
            <div className="form-item">
              <label>Cases closed</label>
              <div className="form-item-row">
                <DatePickerField fieldName="date_closed_from" placeholderText="From" />
                <DatePickerField fieldName="date_closed_to" placeholderText="Through" />
              </div>
            </div>
          </FieldSet>
        </div>
        <div className="action-btn-container">
          <button type="submit" className="btn btn-success btn-search">
            Search
          </button>
          <button
            type="button"
            className="btn btn-link"
            onClick={() => {
              form.reset();
              onReset();
            }}
          >
            Clear
          </button>
        </div>
      </form>
    )}
  />
);

CasesForm.propTypes = {
  filter: PropTypes.any.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
};

export default CasesForm;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/initialForms/criminal/CasesForm.jsx